import ErrorBoundary from "@/react/story/components/ErrorBoundary";
import ConfigProvider from "@/react/story/providers/ConfigProvider";
import ErrorsProvider from "@/react/story/providers/ErrorsProvider";
import FontsProvider from "@/react/story/providers/FontsProvider";
import ItemsProvider from "@/react/story/providers/ItemsProvider";
import LocalesProvider from "@/react/story/providers/LocalesProvider";
import StatsProvider from "@/react/story/providers/StatsProvider";
import StoryProvider from "@/react/story/providers/StoryProvider";
import type { Locale, Story, StoryItem, StoryPage } from "@/react/story/types";
import { QueryClient, QueryClientProvider, } from "@tanstack/react-query";
import type { ReactNode } from "react";

type Props = {
    defaultStory: Story;
    storyPermalink: string;
    defaultItems: StoryItem[];
    defaultStories: Story[];
    defaultPages: StoryPage[];
    temporaryEndpoint: string;
    defaultLocale: Locale;
    presetLocales: Locale[];
    statsEndpoint: string;
    statsToken: string;
    isOnline: boolean;
    children: ReactNode;
}

const queryClient = new QueryClient();

export default function App(props: Props) {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <ConfigProvider temporaryEndpoint={props.temporaryEndpoint} isOnline={props.isOnline} storyPermalink={props.storyPermalink}>
                    <StoryProvider defaultStory={props.defaultStory}>
                        <LocalesProvider defaultLocale={props.defaultLocale} presetLocales={props.presetLocales}>
                            <ItemsProvider
                                defaultItems={props.defaultItems}
                                defaultStories={props.defaultStories}
                                defaultPages={props.defaultPages}
                            >
                                <StatsProvider statsEndpoint={props.statsEndpoint} statsToken={props.statsToken}>
                                    <FontsProvider>
                                        <ErrorsProvider>
                                            {props.children}
                                        </ErrorsProvider>
                                    </FontsProvider>
                                </StatsProvider>
                            </ItemsProvider>
                        </LocalesProvider>
                    </StoryProvider>
                </ConfigProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
}
